import * as LocalizationApi from './localization-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import { patientIdentifierLoaded } from './actions/creators';

export const loadPatientIdentifierLabel = (language) => (dispatch) =>
  LocalizationApi.getLocalizedContent('PatientIdentifierLabel', language).then(
    (response) => dispatch(patientIdentifierLoaded(response.data)),
    () => dispatch(MsgBarActions.showErrorMessage())
  );

export const getLocalizedStringContent = (languageCode, contentKey, callback) => {
  LocalizationApi.getLocalizedContent(contentKey, languageCode).then(callback);
};

export const getLocalizedFacilityStringContent = (facilityId, languageCode, contentKey, callback) => {
  LocalizationApi.getLocalizedFacilityContent(contentKey, facilityId, languageCode).then(callback);
};